<template>
  <div class="landlord-login-page d-flex flex-column flex-lg-row flex-column-fluid">
    <!--begin::Aside-->
    <div class="landlord-login-aside d-flex flex-column flex-lg-row-auto w-xl-600px position-xl-relative">
      <div class="d-flex flex-column position-xl-fixed top-0 bottom-0 w-xl-600px scroll-y">
        <div class="d-flex flex-column flex-center flex-grow-1 text-center p-10 pt-lg-20">
          <h1 class="fw-bolder fs-2qx pb-5 pb-md-10 landlord-login-title">Administration</h1>
          <p class="fw-bold fs-2 landlord-login-subtitle">
            {{ $t('landlord.admin_panel_description') }}
          </p>
          <div class="d-flex justify-content-center align-items-center mt-10">
            <img alt="Logo" src="/assets/media/r2b_login.jpg" class="landlord-login-hero-img" />
          </div>
        </div>
        <div class="landlord-login-aside-logo">
          <img alt="Qomerxia" src="/assets/media/logos/qomerxia-logo.png" class="h-20px" />
        </div>
      </div>
    </div>
    <!--end::Aside-->

    <!--begin::Body-->
    <div class="landlord-login-body d-flex flex-column flex-lg-row-fluid py-10">
      <div class="d-flex flex-center flex-column flex-column-fluid">
        <div class="landlord-login-form-card w-lg-500px p-10 p-lg-15 mx-auto">
          <form id="kt_landlord_sign_in_form" class="form w-100" novalidate="novalidate"
                @submit.prevent="validateBeforeSubmit">
            <div class="text-center mb-10">
              <img alt="Qomerxia" src="/assets/media/logos/qomerxia-logo.png" class="h-45px mb-6 d-lg-none" />
              <h1 class="text-dark mb-3 mt-10">{{ $t('landlord.admin_login') }}</h1>
              <p class="text-gray-400 fw-bold fs-4">{{ $t('landlord.admin_login_subtitle') }}</p>
            </div>

            <div class="fv-row mb-8">
              <label class="form-label fs-6 fw-bolder text-dark mb-2">{{ $t('auth.email') }}</label>
              <div class="position-relative">
                <span class="landlord-login-input-icon">
                  <i class="bi bi-envelope fs-4"></i>
                </span>
                <input v-model="loginData.email" autocomplete="off"
                       class="form-control form-control-lg form-control-solid landlord-login-input"
                       name="email" type="email" :placeholder="$t('auth.email')" />
              </div>
            </div>

            <div class="fv-row mb-8">
              <label class="form-label fw-bolder text-dark fs-6 mb-2">{{ $t('auth.password') }}</label>
              <div class="position-relative">
                <span class="landlord-login-input-icon">
                  <i class="bi bi-lock fs-4"></i>
                </span>
                <input v-model="loginData.password" autocomplete="off"
                       class="form-control form-control-lg form-control-solid landlord-login-input landlord-login-input-password"
                       name="password" :type="showPassword ? 'text' : 'password'" :placeholder="$t('auth.password')" />
                <span class="landlord-login-eye-icon" @click="showPassword = !showPassword">
                  <i :class="showPassword ? 'bi bi-eye' : 'bi bi-eye-slash'" class="fs-4"></i>
                </span>
              </div>
            </div>

            <div class="d-grid mt-10">
              <button id="kt_landlord_sign_in_submit" :disabled="isLoading"
                      class="btn btn-lg btn-primary landlord-login-btn"
                      type="submit">
                <span class="indicator-label">{{ $t('auth.login') }}</span>
                <span v-if="isLoading" class="indicator-progress">
                  {{ $t('loading') }}
                  <span class="spinner-border spinner-border-sm align-middle ms-2"></span>
                </span>
              </button>
            </div>
          </form>
        </div>
      </div>

      <div class="d-flex flex-center flex-wrap fs-6 p-5 pb-0">
        <div class="d-flex flex-center fw-bold fs-6">
          <span class="text-muted text-hover-primary px-2">{{ $t('powered') }}
           <!-- <a target="_blank" href="https://netbyus.com">{{ $t('poweredby') }}</a>-->
          </span>
          <span class="text-muted text-hover-primary px-2">{{ new Date().getFullYear() }}</span>
        </div>
      </div>
    </div>
    <!--end::Body-->
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
    name: 'LandlordLoginView',
    data() {
        return {
            loginData: {
                email: '',
                password: ''
            },
            showPassword: false,
            isLoading: false
        }
    },
    methods: {
        ...mapActions('landlordAuth', ['login']),

        async validateBeforeSubmit() {
            this.isLoading = true
            this.login(this.loginData).then(() => {
                window.toastr['success'](i18n.global.t('landlord.login_success'))
                this.$router.push('/landlord/dashboard')
                this.isLoading = false
            }).catch(() => {
                this.isLoading = false
            })
        }
    }
}
</script>

<style scoped>
.landlord-login-page {
  min-height: 100vh;
}

.landlord-login-aside {
  background: linear-gradient(135deg, rgba(var(--platform-primary-rgb, 11, 61, 135), 0.06) 0%, #fff 50%, rgba(var(--platform-primary-rgb, 11, 61, 135), 0.1) 100%);
  height: 100vh;
  box-shadow: 4px 0 24px rgba(var(--platform-primary-rgb, 11, 61, 135), 0.15);
}

.landlord-login-hero-img {
  max-height: 360px;
  border-radius: 16px;
  box-shadow: 0 8px 32px rgba(var(--platform-primary-rgb, 11, 61, 135), 0.2);
  object-fit: cover;
}

.landlord-login-title {
  color: #000000;
}

.landlord-login-subtitle {
  color: #000000;
}

.landlord-login-aside-logo {
  position: absolute;
  bottom: 20px;
  right: 0;
  padding: 10px;
}

.landlord-login-form-card {
  background: #ffffff;
  border-radius: 16px;
  box-shadow: 0 2px 20px rgba(0, 0, 0, 0.06);
}

.landlord-login-input-icon {
  position: absolute;
  left: 14px;
  top: 50%;
  transform: translateY(-50%);
  color: #b5b5c3;
  z-index: 3;
  pointer-events: none;
}

.landlord-login-input {
  padding-left: 42px !important;
  border-radius: 10px !important;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}

.landlord-login-input:focus {
  border-color: var(--platform-primary, #0b3d87) !important;
  box-shadow: 0 0 0 3px rgba(var(--platform-primary-rgb, 11, 61, 135), 0.15) !important;
}

.landlord-login-eye-icon {
  position: absolute;
  right: 14px;
  top: 50%;
  transform: translateY(-50%);
  color: #b5b5c3;
  cursor: pointer;
  z-index: 3;
  transition: color 0.2s ease;
}

.landlord-login-eye-icon:hover {
  color: var(--platform-primary, #0b3d87);
}

.landlord-login-input-password {
  padding-right: 42px !important;
}

.landlord-login-btn {
  width: 100%;
  border-radius: 10px !important;
  padding: 12px 0 !important;
  font-size: 1.1rem !important;
  letter-spacing: 0.3px;
  background-color: var(--platform-primary, #0b3d87) !important;
  border-color: var(--platform-primary, #0b3d87) !important;
  transition: transform 0.15s ease, box-shadow 0.15s ease;
}

.landlord-login-btn:hover:not(:disabled) {
  transform: translateY(-1px);
  box-shadow: 0 6px 20px rgba(var(--platform-primary-rgb, 11, 61, 135), 0.35);
}

.landlord-login-btn:active:not(:disabled) {
  transform: translateY(0);
}

/* Mobile et tablette : formulaire seul, sur la hauteur visible de l'écran (100dvh exclut la
   barre d'adresse, contrairement à 100vh) — le panneau d'accueil et son image sont masqués */
@media (max-width: 991.98px) {
  .landlord-login-page {
    min-height: 100dvh;
  }

  .landlord-login-aside {
    display: none !important;
  }

  .landlord-login-body {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }

  .landlord-login-form-card {
    box-shadow: none;
    padding: 1.5rem !important;
  }

  .landlord-login-form-card h1 {
    margin-top: 0 !important;
  }

  .landlord-login-form-card .mb-8 {
    margin-bottom: 1.25rem !important;
  }
}

/* Écrans de faible hauteur (laptop, fenêtre réduite) : éviter que l'aside déborde de 100vh */
@media (max-height: 700px) {
  .landlord-login-hero-img {
    max-height: 180px;
  }
}
</style>
